export enum LocalStorage {
  INC_NOTIFICATIONS = "INC_NOTIFICATIONS",
  TIME_FRAME = "TIME_FRAME",
  FEED_VIEW = "FEED_VIEW",
  SHOW_OPEN_DISPATCHES_ONLY = "SHOW_OPEN_DISPATCHES_ONLY",
  FEED_AREA = "FEED_AREA",
  FEED_REGION = "FEED_REGION",
}
